module.exports = __webpack_public_path__ + "img/scuola2_white.b0021a14.svg";